export enum AvailableIpdContentTypeEnum {
    Basic = 'Basic',
    Full = 'Full',
}
